module.exports = __webpack_public_path__ + "assets/img/18.a454d89e.png";